module.exports = __webpack_public_path__ + "img/upfilter.55a1d3d3.svg";